export default "__VITE_ASSET__aa196839__"